import React from "react";
import DataGridTableAdapter from "./DataGridTableAdapter";
import DiffArrow from "./DiffArrow";

class LeaderBoardTeamAoe2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: [] };
  }

  apiUrl = "https://api.aoeitalia.com/v1/player";

  refreshTable() {
    fetch(this.apiUrl)
      .then((response) => response.json())
      .then((data) => data.data)
      .then((players) =>
        this.setState({
          data: players.sort(function (a, b) { return parseInt(b.elo_tg) - parseInt(a.elo_tg) }),
        })
      ).catch(rejected => {
        console.log(rejected);
      });
  }

  componentDidMount() {
    this.refreshTable();
  }

  columns = [
    {
      title: "#",
      type: "numeric",
      sorting: false,
      render: (rowData, row) => {
        return <div> {rowData.tableData.id + 1}</div>
      },
    },
    { title: "Nome", field: "username" },
    { title: "Rating", field: "elo_tg", type: "numeric", defaultSort: "desc" },
    {
      title: "",
      type: "numeric",
      sorting: false,
      render: (rowData) => {
        var diff = rowData.elo_tg - rowData.prev_tg;
        return <DiffArrow diff={diff} />;
      },
    },
    { title: "Max Rating", field: "top_tg", type: "numeric" },
    { title: "Partite", field: "games_tg", type: "numeric" },
    { title: "Ultima partita", field: "lastdt_tg" },
  ];

  render() {
    return (
      <div className="LeaderBoard">
                <DataGridTableAdapter
          columns={this.columns}
          data={this.state.data}
          title=""
          onRefresh={() => this.refreshTable()}
        />
      </div>
    );
  }
}

export default LeaderBoardTeamAoe2;
